import MinRatingRadio from './MinRatingRadio'

export default MinRatingRadio
